import { render, staticRenderFns } from "./HtmlBlockView.vue?vue&type=template&id=7861f633"
import script from "./HtmlBlockView.vue?vue&type=script&lang=js"
export * from "./HtmlBlockView.vue?vue&type=script&lang=js"
import style0 from "./HtmlBlockView.vue?vue&type=style&index=0&id=7861f633&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports